import {Injectable} from '@angular/core';
import { LocalStorageService } from '../../../../teli/services/local-storage.service'

export interface NavigationItem {
  id: string;
  title: string;
  type: 'item' | 'collapse' | 'group';
  translate?: string;
  icon?: string;
  hidden?: boolean;
  url?: string;
  classes?: string;
  exactMatch?: boolean;
  external?: boolean;
  target?: boolean;
  breadcrumbs?: boolean;
  function?: any;
  badge?: {
    title?: string;
    type?: string;
  };
  children?: Navigation[];
}

export interface Navigation extends NavigationItem {
  children?: NavigationItem[];
}


const NavigationAdminItems = [
  {
    id: 'navigation',
    title: 'Navigation',
    type: 'group',
    icon: 'feather icon-monitor',
    children: [
      {
        id: 'teliprovision',
        title: 'Home',
        type: 'item',
        classes: 'nav-item',
        url: '/teliprovision/provision',
        icon: 'feather icon-home',
        breadcrumbs: false
      },{
        id: 'teliadminservices',
        title: 'Admin Services',
        type: 'collapse',
        classes: 'nav-item',
        icon: 'feather icon-sliders',
        children: [
          {
            id: 'teliadmindata',
            title: 'Device Data',
            type: 'item',
            url: '/teliadminservices/admindevices',
            breadcrumbs: false
          },
          {
            id: 'teliadminsetup',
            title: 'Device Setup',
            type: 'item',
            url: '/teliadminservices/admindevicesetup/devicesetup',
            breadcrumbs: false
          },
          {
            id: 'teliadminassign',
            title: 'Setup Users pods',
            type: 'item',
            url: '/teliadminservices/admindeviceassign/deviceassign',
            breadcrumbs: false
          },
          {
            id: 'teliadminorders',
            title: 'Place Orders',
            type: 'item',
            url: '/teliadminservices/adminorders/orders',
            breadcrumbs: false
          }

        ]
      },{
        id: 'tandc',
        title: 'Terms and Services',
        type: 'collapse',
        classes: 'nav-item',
        icon: 'feather icon-sliders',
        children: [
          {
            id: 'ts',
            title: 'Terms of Service',
            type: 'item',
            external: true,
            target: '_blank',
            url: '/assets/telii/termofservice.html',
            breadcrumbs: false
          },
          {
            id: 'priv',
            title: 'Privacy Statement',
            type: 'item',
            external: true,
            target: '_blank',
            url: '/privacy',
            breadcrumbs: false
          },
          {
            id: 'cookie',
            title: 'Cookie Policy',
            type: 'item',
            external: true,
            target: '_blank',
            url: '/assets/telii/cookiepolicy.html',
            breadcrumbs: false
          }
          /*
          {
            id: 'faq',
            title: 'FAQ',
            type: 'item',
            external: true,
            target: '_blank',
            url: 'https://teliiport.webflow.io/',
            breadcrumbs: false
          }
          */
        ]
      }
    ]
  }
];

const NavigationItems = [
  {
    id: 'navigation',
    title: 'Navigation',
    type: 'group',
    icon: 'feather icon-monitor',
    children: [
      {
        id: 'teliprovision',
        title: 'Home',
        type: 'item',
        classes: 'nav-item',
        url: '/teliprovision/provision',
        icon: 'feather icon-home',
        breadcrumbs: false
      },{
        id: 'orders',
        title: 'Orders',
        type: 'item',
        icon: 'feather icon-bar-chart',
        url: '/telireports/reports/orders',
        breadcrumbs: false
      },{
        id: 'tandc',
        title: 'Terms and Services',
        type: 'collapse',
        classes: 'nav-item',
        icon: 'feather icon-sliders',
        children: [
          {
            id: 'ts',
            title: 'Terms of Service',
            type: 'item',
            external: true,
            target: '_blank',
            url: '/assets/telii/termofservice.html',
            breadcrumbs: false
          },
          {
            id: 'priv',
            title: 'Privacy Statement',
            type: 'item',
            external: true,
            target: '_blank',
            url: '/assets/telii/privacypolicy.html',
            breadcrumbs: false
          },
          {
            id: 'cookie',
            title: 'Cookie Policy',
            type: 'item',
            external: true,
            target: '_blank',
            url: '/assets/telii/cookiepolicy.html',
            breadcrumbs: false
          }
          /*
          {
            id: 'faq',
            title: 'FAQ',
            type: 'item',
            external: true,
            target: '_blank',
            url: 'https://teliiport.webflow.io/',
            breadcrumbs: false
          }
          */
        ]
      }
      /*
      ,{
        id: 'telireports',
        title: 'Reports',
        type: 'collapse',
        icon: 'feather icon-bar-chart',
        children: [
          {
            id: 'orders',
            title: 'Orders',
            type: 'item',
            url: '/telireports/reports/orders',
            breadcrumbs: false
          }
        ]
      }
      */
    ]
  }
];

@Injectable()
export class NavigationItem {

  public usrrole = "USR";
  constructor(private localStorage:LocalStorageService) {
    this.usrrole = localStorage.getItem("role");
    //console.log("Came here...in Constructor..ROLE:" + this.usrrole);
  }

  public getUserRole() {
    return this.usrrole;
  }

  public get() {
    if(this.usrrole == "ADM") {
      return NavigationAdminItems;
    } else {
      return NavigationItems;
    }


  }
}
